var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export function currencyFormat(currencyValue, options) {
    var num = parseFloat(removeCurrencyAndCommas(currencyValue));
    if (Number.isNaN(num))
        return '';
    var _a = options || {}, minimumFractionDigits = _a.minimumFractionDigits, maximumFractionDigits = _a.maximumFractionDigits, rest = __rest(_a, ["minimumFractionDigits", "maximumFractionDigits"]);
    var USDollar = new Intl.NumberFormat('en-US', __assign({ style: 'currency', currency: 'USD', minimumFractionDigits: minimumFractionDigits || 2, maximumFractionDigits: maximumFractionDigits || 2 }, rest));
    if (options === null || options === void 0 ? void 0 : options.omitDollarSign) {
        return USDollar.format(num).replace('$', '');
    }
    return USDollar.format(num);
}
export var removeCurrencyAndCommas = function (value) {
    return value.replace(/[^0-9.-]+/g, '');
};
